import * as React from 'react';

import CartActions from 'src/components/CartView/components/CartActions/CartActions';
import CheckoutSummary from './components/CheckoutSummary';
import GridTable from './components/ItemsTable/GridTable';
import Breadcrumbs from '../common/Breadcrumbs';
import ShippingToChange from '../ShippingToChange/ShippingToChange';
import ProductSFMStandAlone from '../common/ProductSFMStandAlone';
import GlobalDeliverAddressChange from 'src/components/GlobalDeliverAddressChange';
import Alert from 'src/components/common/Alert';
import FileModal from './components/FileModal';

import LocationModel from 'src/model/location.model';
import { IWarrantyProvider } from 'src/model/warranty.model';
import AddressModel from 'src/model/address.model';
import CartItemModel from 'src/model/cartItem.model';
import UserModel from 'src/model/user.model';
import CartModel from 'src/model/cart.model';
import { ICartError, ICartSuccess } from 'src/store/modules/cart/reducers';

import { isNumber } from 'util';
import './CartView.scss';
import OneTimeAddressModel from 'src/model/oneTimeAddress.model';
import env from 'src/shared/env';
import i18n from 'src/translation/i18n';

interface ICartViewProps {
  items: CartModel['items'];
  itemCount: number;
  deliverMethod: string;
  deliveryLocation: LocationModel;
  deliveryLocationCode: string;
  suppliedFromCode: string;
  subtotal: string;
  isPending: boolean;
  isPendingList: boolean;
  isFileStatus: boolean;
  updating: boolean;
  userData: UserModel;
  error: ICartError;
  onLoad: () => void;
  onRemoveItem: (itemID: number) => void;
  onClearCart: () => void;
  onAddItemSimple: (partNumber: string, quantity: number) => void;
  onAddItem: (
    claims: string,
    delivery: string,
    deliveryLocation: string,
    oneTimeAddress: OneTimeAddressModel,
    partNumber: string,
    quantity: number,
    rushOrder: boolean,
    shipmentMarking: string,
    shipsfrom: string,
    ticketNumber: string,
    warrantyProvider: string
  ) => void;
  onUpdateItem: (
    claims: string,
    id: number,
    quantity: number,
    shipmentMarking: string,
    shipsfrom: string,
    warrantyProvider: string,
    rushOrder: boolean,
    ticketNumber: string,
    isRefresh: boolean
  ) => void;
  onChangeShipTo: (address: AddressModel) => void;
  onUploadItemsFromFile: (file: FormData) => void;
  onSwitchDeliverMethod: (
    delivery: string,
    deliveryLocation: string,
    oneTimeAddress?: OneTimeAddressModel | null
  ) => void;
  onSwitchShipFrom: (deliveryLocation: string) => void;
  warrantyProviders: IWarrantyProvider[];
  getWarrantyProviders: () => void;
  cartSuccess: ICartSuccess;
  closeAlertSuccess: (success: ICartSuccess) => void;
  updateCartItemQuantityAnalytics: (data: any) => void;
  onFoundInactivePart: (itemID: number) => void;
  t?: any;
}
interface ICartViewState {
  partNumberToAdd: string;
  itemQuantityToAdd: number;
  showChangeShipTo: boolean;
  showChangeShipFrom: boolean;
  showChangeGlobalShipping: boolean;
  showFileModal: boolean;
  selectedPart: CartItemModel;
  changePickUpIn: boolean;
  showUpdating: boolean;
  interQty: number;
  updatedValues: object;
  invalidQtys: { [key: string]: number };
  warningAlert: {
    show: boolean;
    message: string;
  };
  shipChange: boolean;
  hardCreditHoldCartMsg: string;
  errorAlert: {
    show: boolean;
    message: string;
  };
  isCheckOutAllowed: boolean;

}

class CartView extends React.Component<ICartViewProps, ICartViewState> {
  public state: ICartViewState = {
    partNumberToAdd: '',
    itemQuantityToAdd: 1,
    showChangeShipTo: false,
    showChangeShipFrom: false,
    showChangeGlobalShipping: false,
    showFileModal: false,
    selectedPart: null,
    changePickUpIn: false,
    showUpdating: false,
    interQty: 1,
    updatedValues: { values: [] },
    invalidQtys: {},
    warningAlert: {
      show: false,
      message: ''
    },
    shipChange: false,
    hardCreditHoldCartMsg: `${i18n.t('common.hardCreditHoldOrderCannotBeProcessed')} ${
      env.REACT_APP_BASE_ENVIRONMENT === 'US'
        ? '1-800-841-4060.'
        : '1-866-985-5301.'
    }`,
    errorAlert: {
      show: false,
      message: ''
    },
    isCheckOutAllowed: true
  };

  public componentDidMount() {
    this.props.onLoad();
    this.props.getWarrantyProviders();
    localStorage.removeItem("orderEmail");
    localStorage.removeItem("orderPhone");
    localStorage.removeItem("isEmailPhoneUpdated");
  }
    



  public componentDidUpdate(prevProps: ICartViewProps) {
    if (prevProps.items !== this.props.items) {
      this.setState({ invalidQtys: {} });
      this.setState({ updatedValues: { values: [] } });
       /* Don't allow backorders for consignment warehouse */
       const consignBackOrderArr: any[] = [];
    const items = this.props.items;
    if (Object.keys(items).length > 0) {
        Object.keys(items).forEach(key => {
        const item = items[key];

        const isConsignment =
          item?.shipsfrom?.name?.includes("Consignment warehouse");

        const isQtyExceeded =
          Number(item?.quantity) > Number(item?.amountInStock);

        if (isConsignment && isQtyExceeded) {
          consignBackOrderArr.push(1);
        }
       
      });
    }
    if(consignBackOrderArr.length>0){
      this.setState({
        isCheckOutAllowed: false
      });
    } else {
      this.setState({
        isCheckOutAllowed: true
      });
    }
    }
  }

  private changeItemToAdd = (partID: string) => {
    this.setState({ partNumberToAdd: partID });
  };

  private changeItemQuantity = (quantity: number) => {
    this.setState({ itemQuantityToAdd: quantity });
  };

  private validItemAndQuantity(itemID: string, quantity: number) {
    return itemID !== '' && quantity && isNumber(quantity);
  }

  private addItemToCart = () => {
    const { partNumberToAdd, itemQuantityToAdd } = this.state;
    if (!this.validItemAndQuantity(partNumberToAdd, itemQuantityToAdd)) {
      return;
    }

    if (this.props.onAddItemSimple) {
      this.props.onAddItemSimple(partNumberToAdd, itemQuantityToAdd);
    }
  };

  private handleShowChangeShipTo = () => {
    this.setState(prevState => ({
      showChangeShipTo: !prevState.showChangeShipTo
    }));
  };

  private handleShowChangeShipFrom = (item?: CartItemModel) => {
    this.setState({
      showChangeShipFrom: true,
      selectedPart: item
    });
  };

  private handleCloseChangeShipFrom = () => {
    this.setState({
      showChangeShipFrom: false,
      selectedPart: null
    });
  };

  private handleChangeShipFrom = (selectedAddresses: object) => {
    let first: boolean = true;
    for (const key in selectedAddresses) {
      if (selectedAddresses.hasOwnProperty(key)) {
        if (first) {
          this.setState({ showUpdating: true });
          this.props.onUpdateItem(
            this.state.selectedPart.claims
              ? this.state.selectedPart.claims
              : '',
            this.state.selectedPart.id,
            Number(selectedAddresses[key].qty),
            this.state.selectedPart.shipmentMarking,
            key,
            this.state.selectedPart.warrantyProvider
              ? this.state.selectedPart.warrantyProvider
              : '',
            this.state.selectedPart.rushOrder,
            this.state.selectedPart.ticketNumber,
            true
          );
          first = false;
        } else {
          this.props.onAddItem(
            this.state.selectedPart.claims,
            this.props.deliverMethod,
            this.props.deliveryLocation.code,
            null,
            `${this.state.selectedPart.manufacturerCode}  ${this.state.selectedPart.name}`,
            Number(selectedAddresses[key].qty),
            this.state.selectedPart.rushOrder,
            this.state.selectedPart.shipmentMarking,
            key,
            this.state.selectedPart.ticketNumber,
            this.state.selectedPart.warrantyProvider
              ? this.state.selectedPart.warrantyProvider
              : ''
          );
        }
      }
    }

    this.setState({ showChangeShipFrom: false });
  };

  private handleShowChangeGlobalShipping = (changePickUpIn: boolean) => {
    this.setState(prevState => ({
      showChangeGlobalShipping: !prevState.showChangeGlobalShipping,
      changePickUpIn
    }));
  };

  private handleChangeGlobalDeliverMethod = (code: string) => {
    if (this.props.deliverMethod === 'Shipping' || this.state.changePickUpIn) {
      this.props.onSwitchShipFrom(code);
      this.setState({ changePickUpIn: false });
    } else {
      this.props.onSwitchDeliverMethod('Pick-Up', code, null);
    }

    this.setState({ showChangeGlobalShipping: false });
  };

  private reload = () => {
    const fileMessage =
      'Error uploading file. Please make sure you are uploading a compatible file (excel, csv or txt).';
    this.props.onLoad();
    if (this.props.error.message === fileMessage) {
      this.handleShowFileModal();
    }
    const invQtys = { ...this.state.invalidQtys };
    if (this.state.selectedPart) {
      delete invQtys[this.state.selectedPart.id];
      this.setState({ invalidQtys: invQtys });
    }
  };

  private handleShowFileModal = () => {
    this.setState(prevState => ({ showFileModal: !prevState.showFileModal }));
  };

  private handleSwitchDeliverMethod = (newDeliveryType: string) => {
    if (newDeliveryType === 'Delivery') {
      this.props.onSwitchDeliverMethod(
        'Delivery',
        this.props.userData.address.number.toString(),
        null
      );
      this.setState({
        shipChange: true
      });
    } else if (newDeliveryType === 'Pick-Up') {
      this.props.onSwitchDeliverMethod('Pick-Up', null, null);
      this.setState({
        shipChange: true
      });
    } else {
      this.props.onSwitchDeliverMethod(
        'Shipping',
        this.props.userData.address.number.toString(),
        null
      );
      this.setState({
        shipChange: true
      });
    }
  };

  // Specific item editing functions

  private handleChangeQuantity = (item: CartItemModel, qty: string, quantity: number, amounInStock: number,state: string) => {
   
    if(Number(qty) <= amounInStock && item.state === 'In Stock No Backorder') {
      this.setState({ interQty: Number(qty) });
    }
    
    if(Number(qty) > amounInStock && item.state === 'In Stock No Backorder') {
      this.setState({ interQty: Number(qty) });
      if (Number(qty) <= 0 || !qty) {
        const invQtys = {
          ...this.state.invalidQtys,
          [item.id.toString()]: Number(qty)
        };
        this.setState({ invalidQtys: invQtys });
      } else {
        const dl = window['dataLayer'] || [];
        dl.push({
          event: 'updateCartItemQty',
          cartops: {
            item: {
              updateQuantity: {
                part: item.productNumber,
                quantity: Number(qty) - item.quantity
              }
            }
          }
        });
        const invQtys = { ...this.state.invalidQtys };
        delete invQtys[item.id];
        this.setState({ invalidQtys: invQtys });
        this.props.updateCartItemQuantityAnalytics({ item, qty });
      }

      this.setState({ showUpdating: true });
      
      this.props.onUpdateItem(
        this.getUpdatedValuesFromObj(item.id, 'claims', item.claims),
        item.id,
        Number(amounInStock),
        this.getUpdatedValuesFromObj(
          item.id,
          'shipmentMarking',
          item.shipmentMarking
        ),
        item.shipsfrom.code,
        this.getUpdatedValuesFromObj(
          item.id,
          'warrantyProvider',
          item.warrantyProvider
        ),
        item.rushOrder,
        this.getUpdatedValuesFromObj(item.id, 'ticketNumber', item.ticketNumber),
        true
        
      );
      
    return;
  } else {

    if (Number(qty) <= 0 || !qty) {
      const invQtys = {
        ...this.state.invalidQtys,
        [item.id.toString()]: Number(qty)
      };
      this.setState({ invalidQtys: invQtys });
    } else {
      const dl = window['dataLayer'] || [];
      dl.push({
        event: 'updateCartItemQty',
        cartops: {
          item: {
            updateQuantity: {
              part: item.productNumber,
              quantity: Number(qty) - item.quantity
            }
          }
        }
      });
      const invQtys = { ...this.state.invalidQtys };
      delete invQtys[item.id];
      this.setState({ invalidQtys: invQtys });
      this.props.updateCartItemQuantityAnalytics({ item, qty });
    }
  
  }

    this.setState({ showUpdating: true });
    this.props.onUpdateItem(
      this.getUpdatedValuesFromObj(item.id, 'claims', item.claims),
      item.id,
      Number(qty),
      this.getUpdatedValuesFromObj(
        item.id,
        'shipmentMarking',
        item.shipmentMarking
      ),
      item.shipsfrom.code,
      this.getUpdatedValuesFromObj(
        item.id,
        'warrantyProvider',
        item.warrantyProvider
      ),
      item.rushOrder,
      this.getUpdatedValuesFromObj(item.id, 'ticketNumber', item.ticketNumber),
      true
    );
  };

  private handleShipmentMarking = (
    item: CartItemModel,
    shipmentMarking: string
  ) => {
    const { t } = this.props;
    if (shipmentMarking.length === 30) {
      this.setState({
        warningAlert: {
          show: true,
          message:
            // 'Maximum allowable length for Shipment marking is 30 characters'
            `${t('productFieldErrors.maxShipmentCharacterErr', { count: 30 })}`
        }
      });
    } else {
      this.setState({
        warningAlert: {
          show: false,
          message: ''
        }
      });
    }
    this.setUpdatedValuesObj(item.id, 'shipmentMarking', shipmentMarking);
    this.setState({ showUpdating: false });
    this.props.onUpdateItem(
      this.getUpdatedValuesFromObj(item.id, 'claims', item.claims),
      item.id,
      item.quantity,
      shipmentMarking,
      item.shipsfrom.code,
      this.getUpdatedValuesFromObj(
        item.id,
        'warrantyProvider',
        item.warrantyProvider
      ),
      item.rushOrder,
      this.getUpdatedValuesFromObj(item.id, 'ticketNumber', item.ticketNumber),
      false
    );
  };

  private setUpdatedValuesObj(sId: number, param: string, value: string) {
    const updatedValues: [any] = this.state.updatedValues['values'];
    const selected = updatedValues.filter(a => a['id'] === sId);
    if (selected.length > 0) {
      selected[0][param] = value;
    } else {
      const newUpdate = {};
      newUpdate['id'] = sId;
      newUpdate[param] = value;
      updatedValues.push(newUpdate);
    }
    this.setState({ updatedValues: { values: updatedValues } });
  }
  private getUpdatedValuesFromObj(id: number, param: string, value: string) {
    const updatedValues: [any] = this.state.updatedValues['values'];
    const selected = updatedValues.filter(a => a['id'] === id);
    if (selected.length > 0 && selected[0][param]) {
      return selected[0][param];
    } else {
      return value;
    }
  }

  private handleTicketNumber = (item: CartItemModel, ticketNumber: string) => {
    const { t } = this.props;
    if (ticketNumber.length === 10) {
      this.setState({
        warningAlert: {
          show: true,
          message:
            // 'Maximum allowable length for Ticket/Dispatch number is 10 characters'
            `${t('productFieldErrors.maxTicketCharactersErr', { count: 10 })}`
        }
      });
    } else {
      this.setState({
        warningAlert: {
          show: false,
          message: ''
        }
      });
    }
    this.setUpdatedValuesObj(item.id, 'ticketNumber', ticketNumber);
    this.setState({ showUpdating: false });
    this.props.onUpdateItem(
      this.getUpdatedValuesFromObj(item.id, 'claims', item.claims),
      item.id,
      item.quantity,
      this.getUpdatedValuesFromObj(
        item.id,
        'shipmentMarking',
        item.shipmentMarking
      ),
      item.shipsfrom.code,
      this.getUpdatedValuesFromObj(
        item.id,
        'warrantyProvider',
        item.warrantyProvider
      ),
      item.rushOrder,
      ticketNumber,
      false
    );
  };

  private onFoundInactivePart = (inactiveStatus: boolean, inactivePartId:[]) => {
    const { t } = this.props;
    if (inactiveStatus === true) {
      this.setState({
        errorAlert: {
          show: true,
          message:
            `${t('cartPage.cartMainInActivePartError')}`
        }
      });
        // Remove Inactive items from cart
       /* inactivePartId.map((val,index)=>{
          this.props.onRemoveItem(val);
        }); */
    } else {
      this.setState({
        errorAlert: {
          show: false,
          message: ''
        }
      });
    }
  };

  private handleChangeWarrantyProvider = (
    item: CartItemModel,
    warrantyProvider: string
  ) => {
    // if (warrantyProvider != null) {
    //   // Clear shipment Marking if we select warranty provider (requirement)
    //   item.shipmentMarking = '';
    // }
    if (warrantyProvider === '') {
      this.setUpdatedValuesObj(item.id, 'claims', '');
      item.claims = '';
    }
    this.setUpdatedValuesObj(item.id, 'warrantyProvider', warrantyProvider);
    this.setState({ showUpdating: false });
    this.props.onUpdateItem(
      this.getUpdatedValuesFromObj(item.id, 'claims', item.claims),
      item.id,
      item.quantity,
      this.getUpdatedValuesFromObj(
        item.id,
        'shipmentMarking',
        item.shipmentMarking
      ),
      item.shipsfrom.code,
      warrantyProvider,
      item.rushOrder,
      this.getUpdatedValuesFromObj(item.id, 'ticketNumber', item.ticketNumber),
      false
    );
  };

  private handleChangeClaims = (item: CartItemModel, claims: string) => {
    const { t } = this.props;
    if (claims.length >= 15) {
      this.setState({
        warningAlert: {
          show: true,
          message:
            // 'Maximum allowable length for Dispatch/Claims is 15 characters'
            `${t('productFieldErrors.maxDispatchClaimsCharactersErr', {
              count: 15
            })}`
        }
      });
    } else {
      this.setState({
        warningAlert: {
          show: false,
          message: ''
        }
      });
    }
    this.setUpdatedValuesObj(item.id, 'claims', claims);
    this.setState({ showUpdating: false });

    this.props.onUpdateItem(
      claims,
      item.id,
      item.quantity,
      this.getUpdatedValuesFromObj(
        item.id,
        'shipmentMarking',
        item.shipmentMarking
      ),
      item.shipsfrom.code,
      this.getUpdatedValuesFromObj(
        item.id,
        'warrantyProvider',
        item.warrantyProvider
      ),
      item.rushOrder,
      this.getUpdatedValuesFromObj(item.id, 'ticketNumber', item.ticketNumber),
      false
    );
  };


  private handleRushOrderChange = (item: CartItemModel, rushOrder: boolean) => {
    this.setState({ showUpdating: true });
    this.props.onUpdateItem(
      this.getUpdatedValuesFromObj(item.id, 'claims', item.claims),
      item.id,
      item.quantity,
      this.getUpdatedValuesFromObj(
        item.id,
        'shipmentMarking',
        item.shipmentMarking
      ),
      item.shipsfrom.code,
      this.getUpdatedValuesFromObj(
        item.id,
        'warrantyProvider',
        item.warrantyProvider
      ),
      rushOrder,
      this.getUpdatedValuesFromObj(item.id, 'ticketNumber', item.ticketNumber),
      true
    );
  };

  private handleChangeShipTo = (
    address: AddressModel,
    sendOneTimeAddress: boolean
  ) => {
    this.props.onSwitchDeliverMethod(
      'Shipping',
      sendOneTimeAddress ? 'ONE' : address.number.toString(),
      sendOneTimeAddress
        ? {
            name: address.name,
            addressLine1: address.addressLine1,
            addressLine2: address.addressLine2,
            addressLine3: address.addressLine3,
            addressLine4: address.addressLine4,
            postalCode: address.postalCode,
            stateCode: address.stateCode
          }
        : null
    );
    this.handleShowChangeShipTo();
  };

  public renderShipFrom = () => {
    // Get ship from addresses from items, if every item has the same, show it here
    // If not, show "Different Locations"

    const items = Object.keys(this.props.items).map(i => this.props.items[i]);
    if (items == null || !items.length) {
      return null;
    }
    const locations = items.map(item => item.shipsfrom);
    // The common location if all items have the same one, null otherwise
    const { t } = this.props;
    let location = null;
    if (locations.length !== 0) {
      location = locations.reduce(
        (prev, curr) =>
          prev == null ? null : prev.name === curr?.name ? curr : null,
        locations[0]
      );
    }

    let deliveryLocation: LocationModel;
    if (this.props.deliverMethod === 'Delivery') {
      deliveryLocation = this.props.userData.warehouseInfo;
    }

    if (location != null || deliveryLocation) {
      return (
        <div className="shipping-locations--location">
          <div className="ship-header">
            <i className="rpds-place" />
            {this.props.deliverMethod === 'Shipping'
              ? `${t('cartPage.shipFrom')}:`
              : this.props.deliverMethod === 'Delivery'
              ? `${t('delivery.deliveryFrom')}`
              : `${t('product.suppliedFrom')}:`}
          </div>
          <div className="location-info">
            {this.props.deliverMethod === 'Delivery' ? (
              <>
                <p>
                  <strong>{deliveryLocation?.name}</strong>
                </p>
                <p>{deliveryLocation?.addressLine1}</p>
                <p>{deliveryLocation?.addressLine2}</p>
                <p>
                  {deliveryLocation?.addressLine4},{' '}
                  {deliveryLocation?.stateCode} {deliveryLocation?.postalCode}
                </p>
              </>
            ) : (
              <>
                <p>
                  <strong>
                    {location.name.search(' PICK UP ONLY') > 0 &&
                    env.REACT_APP_BASE_ENVIRONMENT === 'US'
                      ? location.name.slice(
                          0,
                          location.name.search(' PICK UP ONLY') + 1
                        )
                      : location.name}
                  </strong>
                </p>
                <p>{location.addressLine1}</p>
                <p>{location.addressLine2}</p>
                <p>
                  {location.addressLine4}, {location.stateCode}{' '}
                  {location.postalCode}
                </p>
              </>
            )}

            {this.props.deliverMethod === 'Shipping' && (
              <p>
                <a
                  href="javascript:void(0)"
                  onClick={() =>
                    this.handleShowChangeGlobalShipping(
                      this.props.deliverMethod === 'Shipping' ? false : true
                    )
                  }
                >
                  {t('common.change')}
                </a>
              </p>
            )}
          </div>
        </div>
      );
    }
    return (
      <div className="shipping-locations--location">
        <div className="ship-header">
          <i className="rpds-place" />
          {t('cartPage.shipFrom')}:
        </div>
        <div className="location-info">
          <p>{t('cartPage.differentLocations')}</p>
          <p>{t('cartPage.viewItemsBelow')}</p>
        </div>
      </div>
    );
  };

  public renderCart() {
    const { t } = this.props;
    const props = this.props;
    const areThereInvalidQtys = !(
      Object.keys(this.state.invalidQtys).length === 0 &&
      this.state.invalidQtys.constructor === Object
    );
    return (
      <div className="cart-view container-fluid">
        <Breadcrumbs>
          {t('common.home')} / {t('cartPage.breadCrumb')}
        </Breadcrumbs>
        {this.props.isPending ? (
          <div className="loader-container">
            <div className="loader" />
          </div>
        ) : (
          <div className="row cart-view--content">
            <h2 className="rp-cart-view--shopping-cart-title-mobile">
              {t('cartPage.breadCrumb')}
              <small>
                {this.props.itemCount} {t('common.items_plural')}
              </small>
            </h2>
            <div className="rp-cart-view--cart-alert">
              {this.props.userData.creditStopCode === "HARD_STOP" && (
                <Alert
                  styleClass="errorCartAlert"
                  message={this.state.hardCreditHoldCartMsg}
                  icon={'rpds-error'}
                  handleCloseAlert={() => {
                    return;
                  }}
                  type={'error'}
                >
                  <a onClick={this.reload} className="reloadLink">
                    {t('common.reload')}
                  </a>
                </Alert>
              )}

              {this.props.error.hasFailed && (
                <Alert
                  styleClass="errorCartAlert"
                  message={this.props.error.message}
                  icon={'rpds-error'}
                  handleCloseAlert={() => {
                    return;
                  }}
                  type={'error'}
                >
                  <a onClick={this.reload} className="reloadLink">
                    {t('common.reload')}
                  </a>
                </Alert>
              )}
              {this.state.warningAlert.show && (
                <Alert
                  type={'warning'}
                  styleClass="errorCartAlert warningCartAlert"
                  message={this.state.warningAlert.message}
                  icon={'rpds-warning'}
                  handleCloseAlert={this.handleCloseWarningAlert}
                />
              )}
               {this.state.errorAlert.show && (
                <Alert
                  type={'error'}
                  styleClass="errorCartAlert"
                  message={this.state.errorAlert.message}
                  icon={'rpds-error'}
                  handleCloseAlert={() => {
                    return;
                  }}
                />
              )}
              {this.state.shipChange && !this.props.error.hasFailed && (
                <Alert
                  type={'success'}
                  styleClass="rp-lists-alert-cart"
                  message={t('Cartview.shipmentchange')}
                  icon={'rpds-check-circle'}
                  handleCloseAlert={() => {
                    this.setState({
                      shipChange: false
                    });
                  }}
                />
              )}
            </div>
            <div className="col-16 col-md-9 order-md-1 order-2">
              <div className="row cart-view--shipping-section">
                <div className="col">
                  <section className="elevation-2">
                    <h2 className="rp-cart-view--shopping-cart-title-desktop">
                      {t('cartPage.breadCrumb')}
                      <small>{this.props.itemCount} items</small>
                    </h2>

                    <p className="change-shipping">
                      <strong>
                        {this.props.deliverMethod === 'Shipping'
                          ? `${t('product.shippingTab')}:`
                          : this.props.deliverMethod === 'Delivery'
                          ? `${t('delivery.delivery')}`
                          : `${t('cartPage.yourPickStore')}`}
                      </strong>
                      <a
                        href="javascript:void(0)"
                        onClick={e =>
                          this.handleSwitchDeliverMethod(
                            this.props.deliverMethod === 'Shipping'
                              ? 'Pick-Up'
                              : 'Shipping'
                          )
                        }
                      >
                        {this.props.deliverMethod === 'Shipping'
                          ? `${t('cartPage.changeToPickUpStore')}`
                          : `${t('cartPage.changeToShipping')}`}
                      </a>
                      &nbsp;&nbsp;&nbsp;
                      {this.props.userData.isDelivery && (
                        <a
                          href="javascript:void(0)"
                          onClick={e =>
                            this.handleSwitchDeliverMethod(
                              this.props.deliverMethod === 'Delivery'
                                ? `Pick-Up`
                                : 'Delivery'
                            )
                          }
                        >
                          {this.props.userData.isDelivery &&
                          (this.props.deliverMethod === 'Shipping' ||
                            this.props.deliverMethod === 'Pick-Up')
                            ? `${t('delivery.changeToDelivery')}`
                            : `${t('cartPage.changeToPickUpStore')}`}
                        </a>
                      )}
                    </p>

                    <div className="shipping-locations">
                      <div className="shipping-locations--location">
                        <div className="ship-header">
                          <i className="rpds-place" />
                          {this.props.deliverMethod === 'Shipping'
                            ? `${t('cartPage.shipTo')}:`
                            : this.props.deliverMethod === 'Delivery'
                            ? `${t('delivery.deliveryTo')}`
                            : `${t('cartPage.pickUpIn')}:`}
                        </div>
                        <div className="location-info">
                          {this.props.deliveryLocation !== null ? (
                            <React.Fragment>
                              <p>
                                <strong>
                                  {this.props.deliveryLocation.name.search(
                                    ' PICK UP ONLY'
                                  ) > 0 &&
                                  env.REACT_APP_BASE_ENVIRONMENT === 'US'
                                    ? this.props.deliveryLocation.name.slice(
                                        0,
                                        this.props.deliveryLocation.name.search(
                                          ' PICK UP ONLY'
                                        ) + 1
                                      )
                                    : this.props.deliveryLocation.name}
                                </strong>
                              </p>
                              <p>{this.props.deliveryLocation.addressLine1}</p>
                              <p>{this.props.deliveryLocation.addressLine2}</p>
                              <p>
                                {this.props.deliveryLocation.addressLine4},{' '}
                                {this.props.deliveryLocation.stateCode}{' '}
                                {this.props.deliveryLocation.postalCode}
                              </p>
                            </React.Fragment>
                          ) : (
                            <React.Fragment>
                              <p> {t('cartPage.noAddressSelected')} </p>
                            </React.Fragment>
                          )}
                          <p>
                            {this.props.deliverMethod !== 'Delivery' && (
                              <a
                                href="javascript:void(0)"
                                onClick={() =>
                                  this.props.deliverMethod === 'Shipping'
                                    ? this.handleShowChangeShipTo()
                                    : this.handleShowChangeGlobalShipping(false)
                                }
                              >
                                {t('common.change')}
                              </a>
                            )}
                          </p>
                        </div>
                      </div>
                      {this.renderShipFrom()}
                    </div>
                  </section>
                </div>
              </div>
              <div className="row cart-view--items-section">
                {this.props.updating && this.state.showUpdating && (
                  <div className="cart-view--items-section--disable" />
                )}
                <div className="col">
                  <section className="elevation-2">
                    <CartActions
                      onSelectSearchItem={this.changeItemToAdd}
                      onChangeQuantity={this.changeItemQuantity}
                      onClearCart={this.props.onClearCart}
                      onAddItem={this.addItemToCart}
                      onUploadFile={this.handleShowFileModal}
                      cartSuccess={this.props.cartSuccess}
                      onCloseAlertSuccess={this.props.closeAlertSuccess}
                    />
                    <div className="row">
                      <div className="col">
                        <GridTable
                          items={props.items}
                          warrantyProviders={this.props.warrantyProviders}
                          deliverMethod={this.props.deliverMethod}
                          deliverLocation={this.props.deliveryLocation}
                          invalidQtys={this.state.invalidQtys}
                          areThereInvalidQtys={areThereInvalidQtys}
                          onRemoveItem={this.props.onRemoveItem}
                          onOpenChangeShipFrom={this.handleShowChangeShipFrom}
                          handleChangeQuantity={this.handleChangeQuantity}
                          handleShipmentMarking={this.handleShipmentMarking}
                          handleTicketNumber={this.handleTicketNumber}
                          handleChangeWarrantyProvider={
                            this.handleChangeWarrantyProvider
                          }
                          handleChangeClaims={this.handleChangeClaims}
                          handleRushOrderChange={this.handleRushOrderChange}
                          interQty={this.state.interQty}
                          onFoundInactivePart={this.onFoundInactivePart}
                        />
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
            <div className="col-16 col-md-3 order-md-2 order-1">
              <CheckoutSummary
                subtotal={this.props.subtotal}
                itemCount={this.props.itemCount}
                areThereInvalidQtys={areThereInvalidQtys}
                hardCreditHold={this.props.userData.creditStopCode}
                isCheckOutAllowed={this.state.isCheckOutAllowed}
              />
            </div>
            <div className="col-16 col-md-3 order-md-2 order-3 mobile-view-only">
              <CheckoutSummary
                subtotal={this.props.subtotal}
                itemCount={this.props.itemCount}
                areThereInvalidQtys={areThereInvalidQtys}
                hardCreditHold={this.props.userData.creditStopCode}
                isCheckOutAllowed={this.state.isCheckOutAllowed}
              />
            </div>
          </div>
        )}
      </div>
    );
  }

  private renderChangeShipFrom() {
    return (
      this.state.showChangeShipFrom && (
        <ProductSFMStandAlone
          partNumber={this.state.selectedPart.name}
          mfc={this.state.selectedPart.manufacturerCode}
          show={this.state.showChangeShipFrom}
          isPickUp={this.props.deliverMethod === 'Pick-Up' ? true : false}
          deliveryLocationCode={this.props.deliveryLocationCode}
          onClose={this.handleCloseChangeShipFrom}
          onChange={e => this.handleChangeShipFrom(e)}
          selectedAddresses={{
            [this.state.selectedPart.shipsfromCode]: {
              qty: this.state.selectedPart.quantity,
              available: this.state.selectedPart.quantity
            }
          }}
          isDelivery={this.props.deliverMethod === 'Delivery' ? true : false}
          state={this.state.selectedPart.state}
          selectedQty={this.state.selectedPart.quantity}
        />
      )
    );
  }

  private renderChangeGlobalShipFrom() {
    return this.state.showChangeGlobalShipping ? (
      <GlobalDeliverAddressChange
        deliverMethod={this.props.deliverMethod}
        show={this.state.showChangeGlobalShipping}
        showBackorder={true}
        showPickUpOnly={
          this.props.deliverMethod === 'Shipping' || this.state.changePickUpIn
            ? false
            : true
        }
        handleClose={this.handleShowChangeGlobalShipping}
        handleChangeAddress={this.handleChangeGlobalDeliverMethod}
      />
    ) : null;
  }

  private renderFileModal() {
    return this.state.showFileModal ? (
      <FileModal
        onUploadFile={this.props.onUploadItemsFromFile}
        onCloseModal={this.handleShowFileModal}
      />
    ) : null;
  }

  private handleCloseWarningAlert = () => {
    this.setState({
      warningAlert: {
        show: false,
        message: ''
      }
    });
  };

  public render() {
    return this.state.showChangeShipTo ? (
      <ShippingToChange
        handleChangeAddress={this.handleChangeShipTo}
        handleCloseMenu={this.handleShowChangeShipTo}
      />
    ) : (
      <React.Fragment>
        {this.renderFileModal()}
        {this.renderChangeShipFrom()}
        {this.renderChangeGlobalShipFrom()}
        {this.renderCart()}
      </React.Fragment>
    );
  }
}

export default CartView;
